import React from 'react';
import Image1 from 'assets/images/onboarding_gifts_1.png';
import Image2 from 'assets/images/onboarding_gifts_2.png';
import Image3 from 'assets/images/onboarding_gifts_3.svg';
import Image4 from 'assets/images/onboarding_gifts_4.png';

const GiftList = ({ animationCount }) => {
  return (
    <div
      className={`position-relative flex-fill d-md-block onboarding-glasses with-hover ${
        animationCount ? `anim-${animationCount}` : ''
      }`}
    >
      <img src={Image1} alt='shop' className='img-shop-item-glasses' />
      <img src={Image2} alt='glasses' className='img-glasses' />
      <img src={Image3} alt='decor' className='img-decor' />
      <img src={Image4} alt='shop-item' className='img-shop-expanded' />
    </div>
  );
};

export default GiftList;
